import React, { useEffect, useRef, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import axios from 'axios';
import {
    formatMoneda,
    formatoMonto,
    seleccionarCampo,
    validaMonto
} from '../../../util/varios';
import { Mensaje, MensajeSiNo } from '../../mensajes2';
import moment from 'moment';
import { Dimmer } from '../../spinner';

export const ProcesosMontos = (props) => {

    const op = require('../../../modulos/datos');
    const token = JSON.parse(sessionStorage.getItem('jwtToken'));
    const fechasistema = JSON.parse(localStorage.getItem("fechasistema"));

    const btnCancela = useRef();
    const btnAcepta = useRef();
    const btnSalir = useRef();
    const txtMonto = useRef();
    const txtNumCredito = useRef();
    const txtReferencia = useRef();
    const txtFechaPago = useRef();
    const txtMoneda = useRef();
    const txtBanco = useRef();
    const txtBanco2 = useRef();

    const [mostrar1, setMostrar1] = useState(null);
    const [mostrar2, setMostrar2] = useState(null);
    const [banco, setBanco] = useState([]);
    const [bancoC, setBancoC] = useState([]);

    const [numnota, setNumNota] = useState('');
    const [simbol, setSimbol] = useState(null);
    const [combomoneda, setComboMoneda] = useState([]);
    const [activate, setActivate] = useState(false);
    const [idmoney, setIdmoney] = useState(0);
    const [valormoney, setValormoney] = useState(0.00);
    const [valida, setValida] = useState(0);
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });


    const blanquear = () => {
        setActivate(false);
        setNumNota('');
        setValida(0);
        setIdmoney(0);
        setSimbol(null);
        setMostrar1(false);
        setMostrar2(false);
    }

    const cancelar = () => {
        blanquear();
        props.onHideCancelar();

    };

    const onChangeValidar = (e) => {
        e.preventDefault();

        let sigue = true;
        if (props.ope === 1) {

            if (txtFechaPago.current.value === '') {
                setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Seleccione la Fechas de Pago !', icono: 'informacion' });
                txtFechaPago.current.focus()
                sigue = false
            } else if (txtMonto.current.value === '' || txtMonto.current.value === '0,00') {
                setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Introduzca el Monto!', icono: 'informacion' });
                txtMonto.current.focus()
                sigue = false
            } else if (sigue === true) {

                Ejecutar();

            }

        } else if (props.ope === 2 || props.ope === 3 || props.ope === 4 || props.ope === 5 || props.ope === 6) {
            if (txtFechaPago.current.value === '') {
                setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Seleccione la Fechas de Pago !', icono: 'informacion' });
                txtFechaPago.current.focus()
                sigue = false
            } else if (txtReferencia.current.value === '') {
                setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Introduzca el N° de Referencia!', icono: 'informacion' });
                txtReferencia.current.focus()
                sigue = false
            } else if (txtMonto.current.value === '' || txtMonto.current.value === '0,00') {
                setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Introduzca el Monto!', icono: 'informacion' });
                txtMonto.current.focus()
                sigue = false
            } else if (sigue === true) {

                Ejecutar();

            }
        } else if (props.ope === 7) {
            if (txtFechaPago.current.value === '') {
                setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Seleccione la Fechas de Pago !', icono: 'informacion' });
                txtFechaPago.current.focus()
                sigue = false
            } else if (txtMoneda.current.value === '') {
                setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Seleccione el Tipo de Moneda !', icono: 'informacion' });
                txtMoneda.current.focus()
                sigue = false
            } else if (txtMonto.current.value === '' || txtMonto.current.value === '0,00') {
                setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Introduzca el Monto!', icono: 'informacion' });
                txtMonto.current.focus()
                sigue = false
            } else if (sigue === true) {

                Ejecutar();

            }
        } else if (props.ope === 8 || props.ope === 9) {
            if (txtFechaPago.current.value === '') {
                setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Seleccione la Fechas de Pago !', icono: 'informacion' });
                txtFechaPago.current.focus()
                sigue = false
            } else if (txtNumCredito.current.value === '') {
                setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ El Campo Crédito no debe ir Vacio !', icono: 'informacion' });
                txtNumCredito.current.focus()
                sigue = false
            } else if (txtMonto.current.value === '' || txtMonto.current.value === '0,00') {
                setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Introduzca el Monto!', icono: 'informacion' });
                txtMonto.current.focus()
                sigue = false
            } else if (sigue === true) {

                Ejecutar();

            }
        }

    }

    const Ejecutar = () => {

        let datos = [];

        const nom = txtBanco.current.options[txtBanco.current.selectedIndex].text;
        const nom2 = txtBanco2.current.options[txtBanco2.current.selectedIndex].text;
        datos.push({
            fecha: txtFechaPago.current.value,
            monto: txtMonto.current.value.replace(/\./g, '').replace(',', '.'),
            formapago: valida,
            referencia: valida === 1 || valida === 7 || valida === 8 || valida === 9 ? '' : txtReferencia.current.value.trim(),
            tipodivisa: 1,
            simbolo: '',
            notacredito: valida === 8 || valida === 9 ? numnota : '',
            idbanco: valida === 2 || valida === 3 || valida === 4 || valida === 5 || valida === 6 ? txtBanco.current.value : 0,
            idbancocliente: valida === 2 || valida === 3 || valida === 4 || valida === 5 || valida === 6 ? txtBanco2.current.value : 0,
            nombanco: nom,
            nombancliente: nom2,
            valormoneda: 0,
            codigo: null,
            cuentabanco: banco[txtBanco.current.selectedIndex].cuentabancaria,
            idcuentabancaria: banco[txtBanco.current.selectedIndex].idcuentabancaria,
        });
        props.onHideAceptaData(datos);
        cancelar();
    }

    const handleCloseSi = () => {
        setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });

    };

    const cerrarModal = () => {
        blanquear();
        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
    }

    const validarCantidad = (event) => {
        validaMonto(event);
        if (event.target.value === "" || parseFloat(event.target.value.replace(/\./g, "").replace(",", ".")) === 0) {
            event.target.value = "0,00";
        }
        if (event.which >= 37 && event.which <= 40) {
            event.preventDefault();
        }
        if (event.which === 13 || typeof event.which === "undefined") {
            /* if (event.target.value === "" || parseFloat(event.target.value.trim().replace(".", "").replace(",", ".")) === 0.0) {
                event.target.value = "0,00";
            } */
            event.target.value = formatoMonto(event.target.value);
            let char1 = event.target.value.substring(0, 1);
            let char2 = event.target.value.substring(1, 2);
            if (char1 === "0" && char2 !== ",") {
                event.target.value = event.target.value.substring(1, event.target.value.length);
            }

            const valorNumerico = parseFloat(event.target.value.replace(/\./g, '').replace(',', '.') || 0);
            if (valorNumerico > props.restabs) {
                setMensaje({
                    mostrar: true,
                    titulo: 'Notificación',
                    texto: 'El Monto es Mayor al Monto Restante a Pagar.',
                    icono: 'informacion'
                });
                event.target.value = '0,00';
                txtMonto.current?.focus();
            }
        } else if (event.which === 46) {
            return false;
        } else if (event.which >= 48 && event.which <= 57) {
            return true;
        } else if (event.which === 8 || event.which === 0 || event.which === 44) {
            return true;
        } else return false;
    };

    const seleccionarCuentasBancarias = () => {

        let campos = '*';
        let nomtab = 'cuentabancaria';
        let orden = 'idcuentabancaria desc';

        let endpoint = `${op.conexion}/api/comun/seleccionaregistros?&campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

        setActivate(true);

        axios.get(endpoint, {
            headers: {
                'x-access-token': `${token}`,
                app: "admin"
            }
        }).then(function (response) {

            if (response.status === 200) {
                if (response.data.length > 0) {
                    setBanco(response.data);
                }
            }


        }).catch(function (error) {

            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
            setActivate(false);

        }).finally(() => {
            setActivate(false);
        })

    }

    const seleccionarRegistrosBancos = () => {
        setActivate(true);


        let campos = "*";
        let nomtab = "bancos";
        let orden = "idbanco";

        let endpoint = `${op.conexion}/api/comun/seleccionaregistros?&campos=${campos}&nomtab=${nomtab}&orden=${orden}`;


        axios
            .get(endpoint, {
                headers: {
                    "x-access-token": `${token}`,
                    app: "admin"
                },
            })
            .then(function (response) {
                if (response.status == 200) {
                    setActivate(false);
                    var datos = [];

                    setBancoC(response.data);
                }
            })
            .catch(function (error) {
                setMensaje({
                    mostrar: true,
                    titulo: "Error",
                    texto: error.response.data.message,
                    icono: "error",
                });
            })
            .finally(function () {
                setActivate(false);
            });
    };

    useEffect(() => {
        seleccionarCuentasBancarias();
        seleccionarRegistrosBancos();
    }, []);

    useEffect(() => {
        if (txtMonto.current)
            txtMonto.current.value = formatMoneda(props.restabs.toString().replace(",", "").replace(".", ","), ",", ".", 2);
    }, [valida]);

    return (
        <Modal
            {...props}
            size={props.ope > 1 && props.ope < 7 ? "lg" : "sm"}
            aria-labelledby="contained-modal-title-vcenter"
            centered
            style={{
                backgroundColor: '#000000b0'
            }}
            backdrop="static"
            keyboard={false}
            onShow={() => {
                if (parseInt(props.ope) > 0) {
                    setValida(parseInt(props.ope));

                }
            }}
        >
            <Modal.Header className='azulGradiant header-modal'>
                <div className='fw-bold' style={{ color: "#fff" }}><h3>{props.ope === 2 ? 'Pago - (Tarjeta de Débito)' : props.ope === 5 ? 'Pago - (Tarjera de Crédito)'
                    : props.ope === 6 ? 'Pago - (Movil)' : props.ope === 4 ? 'Pago - (Depósito Bancario)' : props.ope === 3 ? 'Pago - (Transferencia Bancaria)' : props.ope === 8 ? 'Pago - (Saldo a Crédito)' : 'Pago - (Anticipo)'}</h3></div>

                <a href='#' ref={btnSalir} onClick={cancelar} className='text-light' ><i className="fas fa-times fa-1x shadow" > {/* Salir */}</i></a>

            </Modal.Header>
            <Modal.Body style={{ backgroundColor: "#FFF" }}>
                <Mensaje mensaje={mensaje}
                    onHide={() => {
                        mensaje.titulo === 'Exito.' ?
                            cerrarModal() :
                            setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
                    }
                    } />
                <MensajeSiNo mensaje={mensajesino}
                    onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />
                <Dimmer active={activate} inverted>

                </Dimmer>
                <div className='col-md-12 row mx-auto px-0'>

                    <div className="row col-md-12 rounded mx-auto m-0 border-azul px-1">


                        {valida === 1 ?
                            <div className='col-12 row m-0 px-0 py-1'>


                                <div className="input-group input-group-sm col-md-4">
                                    <label className="input-group-text" id="inputGroup-sizing-sm">FECHA DE PAGO:</label>
                                    <input type="date" ref={txtFechaPago} disabled={props.ope === 0 ? true : false} defaultValue={moment.utc(fechasistema).format("YYYY-MM-DD")} name='fecha' className="form-control text-center fs-6 text-uppercase" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                                </div>


                                <div className='col-pd-280 px-0 mx-auto'>
                                    <div className="input-group input-group-sm">
                                        <label className="input-group-text" id="inputGroup-sizing-sm">MONTO: </label>
                                        <input autoComplete='off' type="text" disabled={props.ope === 0 ? true : false} ref={txtMonto} defaultValue={'0,00'} onFocus={seleccionarCampo} onKeyUp={validarCantidad} onBlur={validarCantidad} placeholder='0,00' className="form-control bg-transparent fs-6 text-right" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                                    </div>
                                </div>

                            </div> : ''}

                        {valida === 2 || valida === 3 || valida === 4 || valida === 5 || valida === 6 ?
                            <div className='col-12 row m-0 px-0 py-2'>
                                {/* fecha en uso  */}

                                <div className="input-group input-group-sm col-md-5 mb-1">
                                    <label className="input-group-text" id="inputGroup-sizing-sm">FECHA DE PAGO:</label>
                                    <input type="date" ref={txtFechaPago} disabled={props.ope === 0 ? true : false} defaultValue={moment.utc(fechasistema).format("YYYY-MM-DD")} name='fecha' className="form-control text-center fs-6 text-uppercase" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                                </div>
                                <div className='col-md-7 mb-1'></div>

                                <div className="input-group input-group-sm col-md-12 mb-1" >
                                    <label
                                        className="input-group-text"
                                        id="inputGroup-sizing-sm"
                                    >
                                        BANCO DEL CLIENTE:
                                    </label>
                                    <select
                                        className="form-control form-control-sm fs-6 px-1 fw-bold form-select"
                                        disabled={props.ope === 0 ? true : false}
                                        ref={txtBanco2}
                                    >
                                        {bancoC &&
                                            bancoC.map((item, index) => (
                                                <option key={index} value={item.idbanco}>
                                                    {item.nombre}
                                                </option>
                                            ))}
                                    </select>
                                </div>

                                <div className="input-group input-group-sm col-md-12 mb-1">
                                    <label
                                        className="input-group-text"
                                        id="inputGroup-sizing-sm"
                                    >
                                        BANCO DESTINO:
                                    </label>
                                    <select
                                        className="form-control form-control-sm fs-6 px-1 fw-bold form-select"
                                        disabled={props.ope === 0 ? true : false}
                                        ref={txtBanco}
                                    >
                                        {banco &&
                                            banco.map((item, index) => (
                                                <option key={index} value={item.idcuentabancaria}>
                                                    {" "}{`${item.nombre} --- ${item.cuentabancaria}`}{" "}
                                                </option>
                                            ))}
                                    </select>
                                </div>

                                <div className="input-group input-group-sm col-md-5 mb-1">
                                    <label className="input-group-text" id="inputGroup-sizing-sm">N° DE REFERANCIA:</label>
                                    <input type="text" ref={txtReferencia} disabled={props.ope === 0 ? true : false} name='fecha' className="form-control fs-6 text-uppercase" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                                </div>
                                <div className='col-md-3'></div>

                                <div className="input-group input-group-sm col-md-4 mb-1">
                                    <label className="input-group-text" id="inputGroup-sizing-sm">MONTO: </label>
                                    <input autoComplete='off' type="text" disabled={props.ope === 0 ? true : false} ref={txtMonto} defaultValue={'0,00'} onFocus={seleccionarCampo} onKeyUp={validarCantidad} onBlur={validarCantidad} placeholder='0,00' className="form-control bg-transparent fs-6 text-right" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                                </div>

                            </div> : ''}



                        {valida === 8 ? <div className='col-12 row m-0 px-0 py-2'>

                            <div className='col-md-6 px-0 mb-1 mx-auto'>
                                <div className="input-group input-group-sm">
                                    <label className="input-group-text" id="inputGroup-sizing-sm">FECHA DE PAGO:</label>
                                    <input type="date" ref={txtFechaPago} disabled={props.ope === 0 ? true : false} defaultValue={moment.utc(fechasistema).format("YYYY-MM-DD")} name='fecha' className="form-control text-center fs-6 text-uppercase" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                                </div>
                            </div>

                            <div className='col-pd-280 px-0 mb-1 mx-auto'>
                                <div className="input-group input-group-sm">
                                    <label className="input-group-text" id="inputGroup-sizing-sm">N° CREDITO: </label>
                                    <input autoComplete='off' type="text" disabled={props.ope === 0 ? true : false} ref={txtNumCredito} className="form-control bg-transparent fs-6" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                                    <button type="button" onClick={() => setMostrar1(true)} disabled={props.ope === 0 ? true : false} className="btn btn-success"><i className="fas fa-search"></i></button>
                                </div>
                            </div>

                            <div className='col-pd-280 px-0 mx-auto'>
                                <div className="input-group input-group-sm">
                                    <label className="input-group-text" id="inputGroup-sizing-sm">MONTO: </label>
                                    <input autoComplete='off' type="text" disabled={true} ref={txtMonto} defaultValue={'0,00'} onFocus={seleccionarCampo} onKeyUp={validarCantidad} onBlur={validarCantidad} placeholder='0,00' className="form-control bg-transparent fs-6 text-right" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                                </div>
                            </div>

                        </div> : ''}

                        {valida === 9 ? <div className='col-12 row m-0 px-0 py-2'>

                            <div className='col-md-6 px-0 mb-1 mx-auto'>
                                <div className="input-group input-group-sm">
                                    <label className="input-group-text" id="inputGroup-sizing-sm">FECHA DE PAGO:</label>
                                    <input type="date" ref={txtFechaPago} disabled={props.ope === 0 ? true : false} defaultValue={moment.utc(fechasistema).format("YYYY-MM-DD")} name='fecha' className="form-control text-center fs-6 text-uppercase" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                                </div>
                            </div>

                            <div className='col-pd-280 px-0 mb-1 mx-auto'>
                                <div className="input-group input-group-sm">
                                    <label className="input-group-text" id="inputGroup-sizing-sm">N° ANTICIPO: </label>
                                    <input autoComplete='off' type="text" disabled={props.ope === 0 ? true : false} ref={txtNumCredito} className="form-control bg-transparent fs-6" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                                    <button type="button" onClick={() => setMostrar2(true)} disabled={props.ope === 0 ? true : false} className="btn btn-success"><i className="fas fa-search"></i></button>
                                </div>
                            </div>

                            <div className='col-pd-280 px-0 mx-auto'>
                                <div className="input-group input-group-sm">
                                    <label className="input-group-text" id="inputGroup-sizing-sm">MONTO: </label>
                                    <input autoComplete='off' type="text" disabled={true} ref={txtMonto} defaultValue={'0,00'} onFocus={seleccionarCampo} onKeyUp={validarCantidad} onBlur={validarCantidad} placeholder='0,00' className="form-control bg-transparent fs-6 text-right" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" />
                                </div>
                            </div>

                        </div> : ''}

                    </div>

                </div>
            </Modal.Body >
            <Modal.Footer>
                <div className="row m-0 col-md-12 mx-auto">
                    <div className='col-md-12 ml-auto px-0 m-0 d-flex justify-content-end'>
                        <button ref={btnAcepta} disabled={props.ope !== 0 ? false : true} onClick={onChangeValidar} className="btn btn-sm rounded-pill btn-success mx-1"><i className="fas fa-check">  Registrar</i></button>
                        <button ref={btnCancela} onClick={cancelar} className="btn btn-danger btn-sm rounded-pill mx-1"><i className="fas fa-window-close"> Cancelar</i></button>
                    </div>
                </div>

            </Modal.Footer>

            {/*  <CatalogoNotaCredito
        show={mostrar1}
        idcliente={props.idclients}
        onHideCancelar={() => setMostrar1(false)}
        onHideAceptaCatalogo={handleAceptaDatos}
      />
      <CatalogoListAnticipos
        show={mostrar2}
        idcliente={props.idclients}
        tipo={'AN'}
        estatus={0}
        onHideCancelar={() => setMostrar2(false)}
        onHideAceptaCatalogo={handleAceptaDatosAnticipos}
      /> */}


        </Modal >
    );
}

